import { Scene } from '../../Scene';
import { EntityBuilder } from './EntityBuilder';
/**
 * 场景构建器 - 提供流式API创建和配置场景
 */
export class SceneBuilder {
    constructor() {
        this.scene = new Scene();
    }
    /**
     * 设置场景名称
     * @param name 场景名称
     * @returns 场景构建器
     */
    named(name) {
        this.scene.name = name;
        return this;
    }
    /**
     * 添加实体
     * @param entity 实体
     * @returns 场景构建器
     */
    withEntity(entity) {
        this.scene.addEntity(entity);
        return this;
    }
    /**
     * 使用实体构建器添加实体
     * @param builderFn 实体构建器函数
     * @returns 场景构建器
     */
    withEntityBuilder(builderFn) {
        const builder = new EntityBuilder(this.scene, this.scene.componentStorageManager);
        const configuredBuilder = builderFn(builder);
        const entity = configuredBuilder.build();
        this.scene.addEntity(entity);
        return this;
    }
    /**
     * 批量添加实体
     * @param entities 实体数组
     * @returns 场景构建器
     */
    withEntities(...entities) {
        for (const entity of entities) {
            this.scene.addEntity(entity);
        }
        return this;
    }
    /**
     * 添加系统
     * @param system 系统实例
     * @returns 场景构建器
     */
    withSystem(system) {
        this.scene.addSystem(system);
        return this;
    }
    /**
     * 批量添加系统
     * @param systems 系统数组
     * @returns 场景构建器
     */
    withSystems(...systems) {
        for (const system of systems) {
            this.scene.addSystem(system);
        }
        return this;
    }
    /**
     * 构建并返回场景
     * @returns 构建的场景
     */
    build() {
        return this.scene;
    }
}
//# sourceMappingURL=SceneBuilder.js.map